import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/constants/images";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div className="relative">
          <Reveal>
            <div className="clip-frame border border-white/10">
              <img
                src={IMAGES.about1}
                alt="Precision CNC milling close-up"
                className="h-[420px] w-full object-cover"
                data-testid="about-image-1"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="relative ml-auto w-[68%] lg:-mt-24">
            <div className="clip-frame spotlight border border-white/10">
              <img
                src={IMAGES.about2}
                alt="Machined precision component"
                className="h-56 w-full object-cover"
                data-testid="about-image-2"
              />
            </div>
          </Reveal>
          <div className="absolute -left-2 top-8 hidden lg:block">
            <div className="origin-left -rotate-90 whitespace-nowrap border-l-2 border-crimson pl-3 font-mono text-[11px] uppercase tracking-[0.24em] text-slate-500">
              Serving Maharashtra · Goa · Belgavi
            </div>
          </div>
        </div>

        <div>
          <SectionHeader eyebrow={t.about.eyebrow} title={t.about.title} />
          <Reveal delay={0.1}>
            <p className="mt-7 leading-relaxed text-slate-300">{t.about.p1}</p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-4 leading-relaxed text-slate-400">{t.about.p2}</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-px border border-white/10 bg-white/10">
            {t.about.stats.map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.07} className="bg-deep p-6" testid={`about-stat-${i}`}>
                <div className="font-display text-3xl font-bold text-white sm:text-4xl" data-testid={`about-stat-value-${i}`}>
                  {s.v}
                </div>
                <div className="mt-1 text-[12px] leading-snug text-slate-400">{s.l}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
